/*
 * @Author: luting
 * @Date: 2022-05-05 19:20:18
 * @lastEditors: luting
 * @LastEditTime: 2022-05-05 19:51:09
 */
import messages from './messages';
import { IRadioBtn } from './types';

// radio数据
export const radioOptions: IRadioBtn[] = [
  {
    label: messages.noticeSet,
    value: 'notice',
    key: 1,
  },
  {
    label: messages.personSet,
    value: 'person',
    key: 2,
  },
];
